import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  Renderer2,
  Input,
} from '@angular/core'

@Component({
  selector: 'app-overlay',
  template: '<ng-content></ng-content>',
  styleUrls: ['./overlay.component.scss'],
})
export class OverlayComponent implements OnInit, OnDestroy, OnChanges {
  @Input() active: boolean = false

  constructor(private renderer: Renderer2) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.active) this.renderer.addClass(document.body, 'noscroll')
    else this.renderer.removeClass(document.body, 'noscroll')
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'noscroll')
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/overlay/overlay.component.ts